<template>
  <div>
    <Layout :pagetitle="$t('General Report')">
      <b-card>
        <b-card class="m-2">
          <b-row>
            <b-col class="m-2">
              <b-row>
                <b-col md="2">
                  <brandSelectorUnique :modelValue="idBrand" @onChange="changeBrandFilter" />
                </b-col>
                <b-col md="3">
                  <input class="form-control h-100" type="date" v-model="startDate" />
                </b-col>
                <b-col md="3">
                  <input class="form-control h-100" type="date" v-model="endDate" />
                </b-col>
                <b-col md="4">
                  <div class="table-buttons h-100">
                    <button class="btn btn-success" :disabled="!reportData.length" @click="exportXls">XLS</button>
                    <button class="ml-1 btn btn-danger" :disabled="!reportData.length" @click="exportPdf">
                      PDF
                    </button>
                    <button
                      class="ml-1 btn btn-primary"
                      :disabled="!idBrand || !startDate || !endDate"
                      @click="getReport"
                    >
                      {{ $t('Buscar') }}
                    </button>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>

        <Table
          class="m-2 mt-3"
          :title="''"
          :items="reportData"
          :columns="columns"
          tableClass="table-sm table-hover"
          :totalItems="reportData.length"
          :showButtons="false"
          :searchable="false"
          :editable="false"
          :removable="false"
          :showPagination="false"
          :isCard="true"
          :customColumn="true"
          :customColumnLabel="$t('Details')"
          @customColumnClick="showDetails"
        />

        <b-modal
          v-model="partnersModal"
          :title="$t('Partners')"
          size="md"
          centered
          hide-footer
          id="partners-modal-names"
        >
          <div class="mr-2 ml-2">
            <b-row v-for="partner in partnersData" :key="partner.id">
              <b-col class="card p-2">
                <b-row>
                  <b-col>
                    {{ $t('Name') }} <b>{{ partner.name }}</b>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    {{ $t('Gross Value') }} <b>{{ $utils.formatMoney(partner.gross_value) }}</b>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    {{ $t('Reward Value') }} <b>{{ $utils.formatMoney(partner.reward_value) }}</b>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-modal>
      </b-card>
    </Layout>
  </div>
</template>

<script>
import moment from 'moment';
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';
import brandSelectorUnique from '@/components/selectors/brandSelectorUnique';
import staticData from './staticData.js';
import { exportPdf } from '@/plugins/jsPdf.js';
import { jsonToXlsx } from '@/utils/xlsExport/jsonToXlsx';

export default {
  components: { Layout, Table, brandSelectorUnique },
  data() {
    return {
      reportData: [],
      idBrand: null,
      startDate: moment(moment().format('YYYY-MM')).format('YYYY-MM-DD'),
      endDate: moment(moment().format('YYYY-MM')).add('months', 1).subtract('days', 1).format('YYYY-MM-DD'),
      summary: {
        qty_affiliates: 0
      },
      partnersModal: false,
      partnersData: []
    };
  },
  methods: {
    showDetails(item) {
      this.partnersModal = true;
      this.partnersData = item?.data?.partners || [];
    },
    getReport() {
      this.$api
        .get('api/report/entryByLevel', {
          idBrand: this.idBrand,
          startDate: this.startDate,
          endDate: this.endDate
        })
        .then((res) => {
          this.loadReport(res.data.data);
        });
    },
    loadReport(dataset = []) {
      this.reportData = [];
      this.summary.qty_affiliates = 0;
      let affiliate_summary = {
        reward_total: 0,
        partner_reward: 0
      };

      dataset.forEach((l3) => {
        l3.level2.forEach((l2) => {
          l2.level1.forEach((l1) => {
            l1.affiliates.forEach((affiliate) => {
              let final_gross_value =
                parseFloat(affiliate.gross_value) - parseFloat(affiliate.reward_accumulative);

              this.reportData.push({
                level3_name: l3.name,
                level2_name: l2.name,
                level1_name: l1.name,
                affiliate_name: affiliate.name,
                reward_mark_count: parseInt(affiliate.reward_mark_count),
                reward_mark: affiliate.reward_mark,
                reward_accumulative: affiliate.reward_accumulative,
                admin_fee: affiliate.admin_fee,
                gross_value: affiliate.gross_value,
                reward_total: affiliate.reward_total,
                final_gross_value: final_gross_value
              });

              affiliate_summary.reward_accumulative = this.$t('Total Reward Affiliate');
              affiliate_summary.reward_total += parseFloat(affiliate?.reward_total || 0);
              this.summary.qty_affiliates++;
            });

            let summary_l1 = {
              gross_value: `${this.$t('Total')} ${l1.name} (L1)`,
              final_gross_value: l1.gross_value,
              partner_reward: l1.reward_value,
              data: l1
            };

            affiliate_summary.partner_reward += parseFloat(l1?.reward_value || 0);
            this.reportData.push(summary_l1);
          });
          let summary_l2 = {
            gross_value: `${this.$t('Total')} ${l2.name} (L2)`,
            final_gross_value: l2.gross_value,
            partner_reward: l2.reward_value,
            data: l2
          };

          affiliate_summary.partner_reward += parseFloat(l2?.reward_value || 0);
          this.reportData.push(summary_l2);
        });
        let summary_l3 = {
          gross_value: `${this.$t('Total')} ${l3.name} (L3)`,
          final_gross_value: l3.gross_value,
          partner_reward: l3.reward_value,
          data: l3
        };
        this.reportData.push(summary_l3);

        affiliate_summary.final_gross_value = this.$t('Total Reward Adm.');
        affiliate_summary.partner_reward += parseFloat(l3?.reward_value || 0);
        this.reportData.push(affiliate_summary);
      });
    },
    changeBrandFilter(idBrand) {
      this.idBrand = idBrand;
    },
    exportXls() {
      let dataset = [];

      this.reportData.forEach((i) => {
        let item = i;

        item.reward_mark_count = this.$utils.formatIntOnlyNumber(item.reward_mark_count);
        item.reward_mark = this.$utils.formatFloatOnlyNumber(item.reward_mark);
        item.reward_accumulative = this.$utils.formatFloatOnlyNumber(item.reward_accumulative);
        item.admin_fee = this.$utils.formatFloatOnlyNumber(item.admin_fee);
        item.gross_value = this.$utils.formatFloatOnlyNumber(item.gross_value);
        item.reward_total = this.$utils.formatFloatOnlyNumber(item.reward_total);
        item.final_gross_value = this.$utils.formatFloatOnlyNumber(item.final_gross_value);
        item.partner_reward = this.$utils.formatFloatOnlyNumber(item.partner_reward);

        item.level3_name = `${item?.level3_name || ''}`;
        item.level2_name = `${item?.level2_name || ''}`;
        item.level1_name = `${item?.level1_name || ''}`;
        item.affiliate_name = `${item?.affiliate_name || ''}`;

        dataset.push(
          this.$utils.pickOrderObj(
            item,
            this.columns.map((c) => c.key)
          )
        );
      });

      jsonToXlsx({
        name: `${this.$t('General Report')} - ${moment().format('DD-MM-YYYY HH:mm')}`,
        headers: this.columns.map((c) => c.label),
        data: dataset
      });
    },
    exportPdf() {
      let columns = this.columns.map((col) => col.label);
      let data = this.reportData.map((item) => {
        let item_array = [];

        this.columns.forEach((col) => {
          if (col.formatter) {
            item_array.push(col.formatter(item[col.key]));
          } else {
            item_array.push(item[col.key]);
          }
        });

        return item_array;
      });

      data[data.length - 1] = data[data.length - 1].map((i) => {
        return {
          content: i ? i : '',
          styles: {
            fontStyle: 'bold'
          }
        };
      });

      exportPdf({
        head: columns,
        body: data,
        title: this.$t('General Report'),
        fileName: `${this.$t('General Report')}.pdf`
      });
    }
  },
  computed: {
    columns() {
      return staticData().columns;
    }
  }
};
</script>

<style lang="scss">
.summary-column {
  white-space: nowrap !important;
  // min-width: 150px;
  flex: 1;
}

.summary-column-sm {
  min-width: 120px;
  flex: 1;
}

.summary-column-lg {
  min-width: 180px;
  flex: 1;
}

#partners-modal-names {
  .modal-content {
    box-shadow: -18px -18px 26px -3px rgba(0, 0, 0, 0.172);
  }
}
</style>
